@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/transcript-subtitles-panel/floating-toolbar/clipping-studio-transcript-floating-toolbar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.floating-toolbar {
  position: fixed;
  z-index: 50;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: rgb(255, 255, 255);
  border-radius: 6px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(0, 0, 0, 0.14);
  font-family: "Open Sans", sans-serif;
  transform: translate(-50%, -100%);
  margin-top: -8px;
}
.floating-toolbar__btn {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
}
.floating-toolbar__btn:hover {
  background: rgb(235, 240, 244);
}
/*# sourceMappingURL=clipping-studio-transcript-floating-toolbar.component.css.map */
